// Components
import AppointmentStatusContent from "./AppointmentStatusContent";
import { Dialog } from "@mui/material";

// Styles
import { styles } from "./styles";

const AppointmentStatusModal = ({
  open = true,
  onClose = () => {},
  title,
  statusVariant = "default",
  patient,
  appointment,
  isMBS = false,
  reasonText,
  clinicMessage,
  statusMessage,
  showAppointmentSummary = true,
  actions = [],
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      sx={{ minWidth: 300 }}
      aria-labelledby="appointment-status-modal-title"
      slotProps={{ paper: { sx: styles.dialogPaper(statusVariant) } }}
    >
      <AppointmentStatusContent
        onClose={onClose}
        title={title}
        statusVariant={statusVariant}
        patient={patient}
        appointment={appointment}
        isMBS={isMBS}
        reasonText={reasonText}
        clinicMessage={clinicMessage}
        statusMessage={statusMessage}
        showAppointmentSummary={showAppointmentSummary}
        actions={actions}
      />
    </Dialog>
  );
};

export default AppointmentStatusModal;
